import { render, staticRenderFns } from "./BaseEmptyData.vue?vue&type=template&id=262151e3&scoped=true"
import script from "./BaseEmptyData.vue?vue&type=script&lang=js"
export * from "./BaseEmptyData.vue?vue&type=script&lang=js"
import style0 from "./BaseEmptyData.vue?vue&type=style&index=0&id=262151e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262151e3",
  null
  
)

export default component.exports